import { INN_MASK, PHONE_MASK, PHONE_PLACEHOLDER } from '@/consts';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { getArrayOfRules, getNewCargoPickUpNameOrganization } from '@/utils/getDataForm';
import { limitInput } from '@/utils/handleChangeForm';

import { inject, ref, toRef, watch } from 'vue';
import { FIOAutocomplete, InnAutocomplete, OrganizationAutocomplete } from '../../../Components';

export default {
  components: {
    OrganizationAutocomplete,
    InnAutocomplete,
    FIOAutocomplete,
  },
  setup() {
    const dataForm = useNewDataFormCargoPickUpStore();

    const ruleFormRef = inject('ruleFormRef', {});

    const disabledThirdPersonType = ref(false);

    const checkDisabledAccount = inject('checkDisabledAccount');

    const handleChangeThirdPerson = () => {
      const payers = [
        toRef(dataForm.thirdPerson, 'whoPaysCargoTransportation'),
        toRef(dataForm.sender, 'whoPaysZabor'),
        toRef(dataForm.consignee, 'whoPaysCargoDelivery'),
        toRef(dataForm.cargoInformation, 'whoPaysForCargoExtraPacking'),
      ];
      const typeOfPayments = [
        toRef(dataForm.thirdPerson, 'typeOfPaymentCargoTransportation'),
        toRef(dataForm.sender, 'typeOfPaymentZabor'),
        toRef(dataForm.consignee, 'typeOfPaymentCargoDelivery'),
        toRef(dataForm.cargoInformation, 'typeOfPaymentForCargoExtraPacking'),
      ];

      let typeOfPaymentSender = 'Наличные';

      for (let i = 0; i < payers.length; i++) {
        const payer = payers[i].value;
        const typeOfPayment = typeOfPayments[i].value;
        if (payer === 'Отправитель') {
          typeOfPaymentSender = typeOfPayment;
          break;
        }
      }

      for (let i = 0; i < payers.length; i++) {
        const payerRef = payers[i];
        const typeOfPaymentRef = typeOfPayments[i];
        if (payerRef.value === 'Третье лицо') {
          payerRef.value = 'Отправитель';
          typeOfPaymentRef.value = typeOfPaymentSender;
        }
      }
    };
    const handleChangePayer = inject('handleChangePayer');

    const handleChangeTypeOfPayment = inject('handleChangeTypeOfPayment');

    const handleChangeTypeOfPerson = inject('handleChangeTypeOfPerson');

    watch(
      () => dataForm.thirdPerson.cargoTransportationCustomer,
      (newValue, oldValue) => {
        dataForm.cargoInformation.cashOnDelivery = false;
        dataForm.cargoInformation.cashOnDeliverySum = '';

        dataForm.cargoInformation.cargoRedemption = false;
        dataForm.cargoInformation.cargoRedemptionSum = '';
        dataForm.cargoInformation.whoPaysTheRansom = null;
        dataForm.cargoInformation.cashOnDeliverySum = '';

        if (newValue === 'Третье лицо') {
          dataForm.thirdPerson.typeThirdPerson = true;
          disabledThirdPersonType.value = true;
        }
        if (oldValue === 'Третье лицо') {
          handleChangeThirdPerson();
          disabledThirdPersonType.value = false;
        }
      }
    );

    watch(dataForm.thirdPerson, (newThirdPerson) => {
      if (newThirdPerson.cargoTransportationCustomer === 'Отправитель') {
        dataForm.sender.senderType = newThirdPerson.typeThirdPerson;
        dataForm.sender.innSender = newThirdPerson.innThirdPerson;
        dataForm.sender.name = newThirdPerson.name;
        dataForm.sender.fioSender = newThirdPerson.fioThirdPerson;
        dataForm.sender.phoneSender = newThirdPerson.phoneThirdPerson;
        dataForm.sender.emailSender = newThirdPerson.emailThirdPerson;
      } else if (newThirdPerson.cargoTransportationCustomer === 'Получатель') {
        dataForm.consignee.consigneeType = newThirdPerson.typeThirdPerson;
        dataForm.consignee.innConsignee = newThirdPerson.innThirdPerson;
        dataForm.consignee.name = newThirdPerson.name;
        dataForm.consignee.fioConsignee = newThirdPerson.fioThirdPerson;
        dataForm.consignee.phoneConsignee = newThirdPerson.phoneThirdPerson;
        dataForm.consignee.emailConsignee = newThirdPerson.emailThirdPerson;
      }
    });

    const options = [
      {
        value: 'Стандарт',
        label: 'Стандарт',
      },
      {
        value: 'Цилиндры',
        label: 'Цилиндры',
      },
      {
        value: 'Шины',
        label: 'Шины',
      },
    ];
    const optionsWhoPays = [
      {
        value: 'Отправитель',
        label: 'Отправитель',
      },
      {
        value: 'Получатель',
        label: 'Получатель',
      },
      {
        value: 'Третье лицо',
        label: 'Третье лицо',
      },
    ];

    return {
      ruleFormRef,
      dataForm,
      handleChangeTypeOfPerson,
      handleChangePayer,
      checkDisabledAccount,
      handleChangeTypeOfPayment,
      options,
      optionsWhoPays,
      PHONE_MASK,
      INN_MASK,
      disabledThirdPersonType,
      PHONE_PLACEHOLDER,
      limitInput,
      getArrayOfRules,
      getNewCargoPickUpNameOrganization,
    };
  },
};
